import { Observable } from 'rxjs';
import { AmPresenciaService } from '../Servicios/am-presencia.service';
import { LlamadasAlertsService } from '../Servicios/llamadas-alerts.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { VariablesService } from '../Servicios/variables.service';
import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';

// CAPACITOR PLUGINS V3
import { Storage } from '@capacitor/storage';
import { iterator } from '@progress/kendo-angular-grid/dist/es2015/utils';

@Injectable({
  providedIn: 'root'
})
export class ProcesosGlobalesService {
  keysEncriptadas: string[];

  constructor(
    public variables: VariablesService,
    public http: HttpClient,
    public alerts: LlamadasAlertsService,
    public amService: AmPresenciaService
  ) { }
  // ESTA VERSION SE UTILIZABA AL PRINCIO SOLO PARA BUZONES DE EMPLEADOS, DESPUES DE CAMBIO A DOCUMENTOS DE LA EMPRESA
  /* async cargarBuzonesFirebaseAntiguo(empleado: DatosEmpleados) {
    console.log("Cargando los buzones del empleado");

    this.variables.cargandoBuzon = true;
    this.variables.tagsEmpresa = [];
    await this.aloDocs.cargarTagsEmpresa().toPromise()
      .then((tags: string[]) => {
        this.variables.tagsEmpresa = tags;
      })
      .catch((err) => {
        this.alerts.presentToast("Error al cargar los tags de la empresa", "danger");
        console.error("Error al cargar los tags de la empresa", err)
      })

    this.variables.buzonRecibidos = [];
    //CARGA DE BUZONES DE RECIBIDOS
    await this.aloDocs.cargarBuzonRecibidos(empleado).toPromise()
      .then((archivosRecibidos: ArchivosFirebase[]) => {
        this.variables.buzonRecibidos = archivosRecibidos as ArchivosFirebase[];
        this.variables.buzonRecibidos = this.variables.buzonRecibidos.reverse();
        if (this.variables.empleadoActual.Codigo == empleado.Codigo) this.variables.recibidosNoLeidos = this.variables.buzonRecibidos.filter(archivo => archivo.leido == "00").length;
      })
      .catch((err) => {
        this.alerts.presentToast("Error al cargar los buzones recibidos", "danger");
        console.error("Error al cargar buzones de recibidos", err)
      })

    this.variables.buzonEnviados = [];
    //CARGA DE BUZONES DE ENVIADOS
    await this.aloDocs.cargarBuzonEnviados(empleado).toPromise()
      .then((archivosEnviados: ArchivosFirebase[]) => {
        this.variables.buzonEnviados = archivosEnviados as ArchivosFirebase[];
        this.variables.buzonEnviados = this.variables.buzonEnviados.reverse();
      })
      .catch((err) => {
        this.alerts.presentToast("Error al cargar los buzones de enviados", "danger");
        console.error("Error al cargar buzones de enviados", err)
      })

    this.variables.cargandoBuzon = false;

  } */

  /**
   * Encripta la variable que se pasa por parámetro
   * @param varAEncriptar Variable a encriptar
   * @returns Variable encriptada
   */
  encriptar(varAEncriptar) {
    let varEncriptada = CryptoJS.AES.encrypt(varAEncriptar, this.variables.claveEncriptacion).toString();
    return varEncriptada;
  }

  /**
   * Desncripta la variable que se pasa por parámetro
   * @param varADesencriptar Variable a desencriptar
   * @returns Variable desencriptada
   */
   desencriptar(varADesencriptar) {
    let varDesencriptado = CryptoJS.AES.decrypt(varADesencriptar, this.variables.claveEncriptacion);
    varDesencriptado = varDesencriptado.toString(CryptoJS.enc.Utf8);
    return varDesencriptado;
  }

  async guardarEnStorage(key: string, value: string) {
    // console.log("Guardando storage de: ", key, value);

    await this.eliminarLocalStorage(key);
    await Storage.set({
      key: this.encriptar(key),
      value: this.encriptar(value)
    });

    // console.log("Guardado en el storage");

  }

  /**
  * Eleimar del local storage en función de la clave pasada por parametro
  * @param key Clave
  */
   async eliminarLocalStorage(key) {
    let keyBorrar: string = '';
    await Storage.keys().then(res => this.keysEncriptadas = res.keys);
    for (var clave of this.keysEncriptadas) {
      if (this.desencriptar(clave) == key) {
        keyBorrar = clave;
      }
    }
    await Storage.remove({ key: keyBorrar });

  }

  /**
  * Obtener value del storage en función de la clave pasada por parámetro
  * @param key Clave
  * @returns value desencriptado
  */
   async obtenerEnStorage(key: string) {
    // console.log("Obteniendo storage de: ", key);

    let keyEncriptada: string = '';
    if (await this.hayDatosAlmacenados()) {
      for (var clave of this.keysEncriptadas) {
        if (this.desencriptar(clave) == key) {
          keyEncriptada = clave;
        }
      }

      // console.log(keyEncriptada);


      if (keyEncriptada != '') {
        const res = await Storage.get({ key: keyEncriptada });
        let value = this.desencriptar(res.value);

        // console.log("Valor desencriptado",value);
        
        return  JSON.parse(value);
      } else return null;
    } else {
      console.log('No hay datos guardado en local storage');
    }
  }




  /**
   * Comprobar si ha datos almacenados en storage
   * @returns si hay o no valores en storage
   */
   async hayDatosAlmacenados() {

    await Storage.keys().then(res => this.keysEncriptadas = res.keys);
    if (this.keysEncriptadas.length > 0) {
      return true;
    } else {
      return false;
    }
  }



}
